import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useSite() {
  const [site, setSite] = useState(null);
  useEffect(() => {
    api.get("/site").then((r) => setSite(r.data)).catch(() => setSite(null));
  }, []);
  return [site, setSite];
}
